<div *ngIf="currentStep == Step.Step1">
  <div class="side-header">
    <p class="side-header-text">Servicios sin proveedor asignado</p>
    <tui-icon
      icon="tuiIconCloseLarge"
      style="cursor: pointer"
      (click)="closeCanvas()"
    ></tui-icon>
  </div>
  <div class="split"></div>
  <div class="description-container">
    <p class="no-provider-alert-text">
      {{ "NO_PROVIDER_SERVICE.SIDE_BAR.0" | translate }}
      <span class="no-provider-alert-text-bolt"
        >{{ NoProviderServices.length }}
        {{ "NO_PROVIDER_SERVICE.SIDE_BAR.1" | translate }}
      </span>
      {{ "NO_PROVIDER_SERVICE.SIDE_BAR.2" | translate }}
    </p>
  </div>
  <div class="searcher-container">
    <div class="search-bar" (click)="focusInput()">
      <img
        src="../../../assets/icons/search-icon.svg"
        alt="Search Icon"
        class="search-icon"
      />
      <input
        #searchInput
        (input)="filterServices(searchInput.value)"
        type="text"
        [placeholder]="'NO_PROVIDER_SERVICE.SIDE_BAR.11' | translate"
        class="search-bar-input"
      />
    </div>
  </div>
  <div class="service-cards-container">
    <div class="service-cards-scroll-container">
      <div *ngFor="let service of FilterdNoProviderServices">
        <app-no-provider-service-card
          [ShowServiceTitle]="true"
          [Selectable]="true"
          [Service]="service"
          (assignProviderEmitter)="selectService($event, service)"
        ></app-no-provider-service-card>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="currentStep == Step.Step2 && ServiceSelected"
  class="step-container"
>
  <div class="step2-content">
    <div class="side-header">
      <p class="side-header-text">
        {{
          "PRODUCT_NAMES." + ServiceSelected.serviceProducts[0].productName
            | translate
        }}
        -
        {{ ServiceSelected.licensePlate }}
      </p>
      <tui-icon
        icon="tuiIconCloseLarge"
        style="cursor: pointer"
        (click)="closeCanvas()"
      ></tui-icon>
    </div>
    <div class="split"></div>

    <div class="description-container">
      <p class="no-provider-alert-text">
        {{ "NO_PROVIDER_SERVICE.SIDE_BAR.3" | translate }}
        {{ ServiceSelected.serviceProducts.length }}
        {{ "NO_PROVIDER_SERVICE.SIDE_BAR.4" | translate }}
      </p>
    </div>

    <div style="margin-top: 10px; padding: 0px 24px">
      <app-no-provider-service-card
        id="service-card"
        [Service]="ServiceSelected"
        (ShowMoreCommentEmitter)="setProductsListHeight()"
      ></app-no-provider-service-card>
    </div>

    <div class="description-container">
      <p class="no-provider-alert-text">
        {{ "NO_PROVIDER_SERVICE.SIDE_BAR.5" | translate }}
        <span class="no-provider-alert-text-bolt"
          >{{ ServiceSelected.serviceProducts.length }}
          {{ "NO_PROVIDER_SERVICE.SIDE_BAR.6" | translate }}
        </span>
      </p>
    </div>

    <div class="cards-container">
      <div
        class="products-cards-scroll-container"
        [style.minHeight]="ProductsListHeight"
        [style.maxHeight]="ProductsListHeight"
      >
        <div
          class="product-row"
          *ngFor="let product of ServiceSelected?.serviceProducts"
        >
          <div>
            <p class="button-text">
              {{ "PRODUCT_NAMES." + product.productName | translate }}
            </p>
            <div
              *ngIf="product.doesRequiresProvider"
              class="assign-status-tag"
              [style.backgroundColor]="
                product.isProviderAssigned
                  ? 'rgba(74, 201, 155, 0.12)'
                  : 'rgba(255, 199, 0, 0.12)'
              "
            >
              {{
                product.isProviderAssigned
                  ? "Proveedor asignado"
                  : "Sin asignar"
              }}
            </div>
          </div>
          <div
            *ngIf="product.doesRequiresProvider && !product.isProviderAssigned"
            class="button-blue button-padding-6-12 button-text-13"
            (click)="selectProductNext(product)"
          >
            {{ "NO_PROVIDER_SERVICE.SIDE_BAR.7" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-container" style="height: 79px">
    <div
      class="button-text"
      style="padding-left: 18px"
      (click)="currentStep = Step.Step1"
    >
      {{ "NO_PROVIDER_SERVICE.SIDE_BAR.8" | translate }}
    </div>
  </div>
</div>

<div
  *ngIf="currentStep == Step.Step3 && ProductSelected && ServiceSelected"
  class="step-container"
>
  <div>
    <div class="side-header">
      <p class="side-header-text">
        {{
          "PRODUCT_NAMES." + ServiceSelected.serviceProducts[0].productName
            | translate
        }}
        -
        {{ ServiceSelected.licensePlate }}
      </p>
      <tui-icon
        icon="tuiIconCloseLarge"
        style="cursor: pointer"
        (click)="closeCanvas()"
      ></tui-icon>
    </div>
    <div class="split"></div>

    <div style="margin-top: 10px; padding: 0px 24px">
      <app-no-provider-service-card
        id="source-div"
        [Service]="ServiceSelected"
        (ShowMoreCommentEmitter)="setProviderListHeight()"
      ></app-no-provider-service-card>
    </div>

    <div style="margin-top: 20px; padding: 0px 24px">
      <div class="select-provider-text">
        {{ "NO_PROVIDER_SERVICE.SIDE_BAR.9" | translate }}
      </div>
      <div class="side-header-text" style="margin-top: 8px">
        {{ "PRODUCT_NAMES." + ProductSelected.productName | translate }}
      </div>
    </div>

    <app-select-provider-list
      [ServiceSelected]="ServiceSelected"
      [ProductId]="ProductSelected.productGuid"
      [ZoneId]="ZoneId"
      [ProviderSelected]="ProviderSelected"
      (providerSelectEmitter)="ProviderSelected = $event"
      [MaxHeight]="ProviderListHeight"
      [MinHeight]="ProviderListHeight"
    ></app-select-provider-list>
  </div>

  <div class="footer-container">
    <div class="button-text" style="padding-left: 18px" (click)="goBack()">
      {{ "NO_PROVIDER_SERVICE.SIDE_BAR.8" | translate }}
    </div>
    <div class="buttons-container">
      <div
        (click)="assignProvider()"
        class="button-green button-padding-10 button-text"
        [ngClass]="{ 'button-disable': !ProviderSelected || SaveLoading }"
      >
        {{ "NO_PROVIDER_SERVICE.SIDE_BAR.10" | translate }}
      </div>

      <img
        class="loading-spinner"
        *ngIf="SaveLoading"
        src="../../../../../assets/loading-spinner.gif"
        alt=""
      />
    </div>
  </div>
</div>
